import React from 'react';
import {Section, Table, NameCell, ValueCell, InputCell, RemoveCell, AddRowButton} from '../components/cells';
import {money} from '../model/format';

/**
 * Current Reimbursements / Proforma Reimbursements sheets - Other Income: RUBS, fees,
 * parking, entered as annual amounts. Categories are editable and rows can be added.
 *
 * `column` is 'current' or 'proforma'.
 */
export default function OtherIncome({column, inputs, calc, setRow, addRow, removeRow}) {
    const listKey = `${column}_other_income`;
    const income = calc.otherIncome[column];
    const title = column === 'current' ? 'Current Reimbursements' : 'Proforma Reimbursements';

    return (
        <div className='mf-tab mf-other-income'>
            <Section
                title={title}
                description='Other Income: RUBS, Fees, Parking (enter Annual)'
                actions={<AddRowButton label='Add Category' onClick={() => addRow(listKey)}/>}
            >
                <Table className='mf-grid-table mf-other-income-table' header={['Category', 'Annual', 'Per Unit', null]}
                    footer={
                        <tr className='mf-total-row'>
                            <NameCell>Total Other Income</NameCell>
                            <ValueCell>{money(income.total)}</ValueCell>
                            <ValueCell>{money(income.total_per_unit)}</ValueCell>
                            <td className='mf-remove-cell'/>
                        </tr>
                    }
                >
                    {income.rows.map((row, index) => (
                        <tr key={index}>
                            <InputCell kind='text' className='mf-label-input' placeholder='Category'
                                value={inputs[listKey][index].category}
                                onChange={value => setRow(listKey, index, 'category', value)}/>
                            <InputCell unit='$'
                                value={inputs[listKey][index].amount}
                                onChange={value => setRow(listKey, index, 'amount', value)}/>
                            <ValueCell>{money(row.per_unit)}</ValueCell>
                            <RemoveCell onRemove={() => removeRow(listKey, index)} disabled={income.rows.length <= 1}/>
                        </tr>
                    ))}
                </Table>
            </Section>
        </div>
    );
}
